export enum ServicesActionTypes {
  SET_SERVICE_RESOURCE = '@@services/SET_SERVICE_RESOURCE',
}
